<script>
export default {
  name: 'sidebar-form'
}
</script>
<template>
</template>



// WEBPACK FOOTER //
// form.vue?2496cdaf